import React from "react";

function orientationCopy(value) {
  if (value === "affords") return "Affording route";
  if (value === "constrains") return "Constraining route";
  if (value === "mixed") return "Mixed / tradeoff";
  return "Unresolved route";
}

export default function PathwayFogTeaser({
  group,
  compact = false,
  onInspect,
}) {
  if (!group) {
    return (
      <div className="rr-pathway-preview empty">
        <span className="v25a-eyebrow">PATHWAY TEASER</span>
        <p>
          Hover a radial sector or a terrain route to preview the same
          materialized pathway in both views.
        </p>
      </div>
    );
  }

  return (
    <button
      type="button"
      className={`rr-pathway-preview ${group.orientation || "unresolved"} ${
        compact ? "compact" : ""
      }`}
      onClick={() => onInspect?.(group)}
    >
      <span className="rr-pathway-preview-fog" aria-hidden="true" />

      <div className="rr-pathway-preview-copy">
        <span className="v25a-eyebrow">{orientationCopy(group.orientation)}</span>
        <b>{group.label}</b>
        <small>
          {group.rootCount} {group.rootCount === 1 ? "root" : "roots"} ·{" "}
          {group.pathwayCount} {group.pathwayCount === 1 ? "pathway" : "pathways"}
          {Number.isFinite(Number(group.averageWarrant))
            ? ` · warrant ${Number(group.averageWarrant).toFixed(2)}`
            : ""}
        </small>
      </div>

      <span className="rr-pathway-preview-action">inspect why →</span>
    </button>
  );
}
